// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/MinusSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var MinusSquareTwoTone = function MinusSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusSquareTwoToneSvg
  }));
};

MinusSquareTwoTone.displayName = 'MinusSquareTwoTone';
export default React.forwardRef(MinusSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MinusSquareTwoTone.js
// module id = 1499
// module chunks = 0